import axios from 'axios';
import Config from '../common/config/config';
import { alertMessage } from '../common/utils/constants';
// import { fetchUserInfo } from '../common/utils/authUtils';
import { store } from '../index';
import {getSimultionFCMT} from '../store/actions/rangeForcating';
// import {getSimultionDetails, getfMUDetails} from '../store/actions/rangeForcating';

export const FcmtSubmit = async (data) => {
    await axios.post(`${Config.API_URL}/testFCMT `, data)
        .then(resp => {
            if (resp.status === 200) {
                console.log('Success')
                store.dispatch(getSimultionFCMT(resp?.data));
                alertMessage('success', 'success', 'Simulated Sucessfully');
            }
        })
        .catch(err => {
            alertMessage('error', err?.message, 'Error while submitting data, Please try again.', 'bottomRight');
        });

    return true;
}